export default __webpack_public_path__ + "static/media/money-back-guarantee-badge.7f29964d.png";